import { mergeTranslations, useTranslation } from "@crehana/i18n";
import { MAIN_MENU_TRANSLATION_KEY } from "../constants.js";
import i18n from "../i18n/index.js";
import useMainMenuContext from "./useMainMenuContext.js";
let RESOURCES_ADDED = false;
const useMainMenuTranslation = ()=>{
    const ctx = useTranslation(MAIN_MENU_TRANSLATION_KEY);
    const { customLocales } = useMainMenuContext();
    if (!RESOURCES_ADDED) {
        const merged = mergeTranslations(i18n, customLocales || {});
        ctx.addResourceBundle(merged);
        RESOURCES_ADDED = true;
    }
    return ctx;
};
const hooks_useMainMenuTranslation = useMainMenuTranslation;
export default hooks_useMainMenuTranslation;
